import { Grid } from '@mui/material'
import { Container } from '@mui/system'
import React from 'react'
import { Btn, Heading, P, SectionWrapper } from '../../Styles/style'
import logo from '../../../assets/footerlogo.png'
import twitter from '../../../assets/twitter.png'
import telegram from '../../../assets/telegram.png'
import medium from '../../../assets/medium.png'
import styled from '@emotion/styled'

const Div = styled.div`
background-color: #BA51FF;
padding: 25px 0;

`

const Footer = () => {
  return (
      <Div>
    <SectionWrapper p="3.5rem 0 1rem 0" m="1.5rem 0 0 0">
      <Container maxWidth="xl">
        <Grid container style={{alignItems:"center"}}>
          <Grid xs={12} sm={6} style={{textAlign: 'left'}}>
            <img src={logo} alt="products" style={{width:'100%', height: 'auto', maxWidth:'230px', marign: 'auto'}} />
          <P maxWidth="400px" style={{color:"#fff"}}>Sanshu Inu is following her big brother (Shiba Inus) footsteps in hopes of becoming as great as him one day! Since she loves Shiba Inu so much, she has decided to create a token that rewards all Sanshu Inu holders with Shiba rewards.

</P>
          </Grid>
          <Grid xs={12} sm={6} style={{textAlign: 'right'}}>
            <P align='right' style={{color:'#fff', display: 'flex', justifyContent: 'flex-end'}}>Follow us:
              <a href=" https://twitter.com/sanshuinutoken" target="_blank" style={{marginLeft: 8}}>
                <img src={twitter} alt="products" style={{width:'100%', height: 'auto', maxWidth:'35px', marign: 'auto'}} />
              </a> 
              <a href="https://t.me/sanshuinuportal" target="_blank" style={{marginLeft: 8}}>
                <img src={telegram} alt="products" style={{width:'100%', height: 'auto', maxWidth:'35px', marign: 'auto'}} />
              </a> 
              <a href="#" target="_blank" style={{marginLeft: 8}}>
                <img src={medium} alt="products" style={{width:'100%', height: 'auto', maxWidth:'35px', marign: 'auto'}} />
              </a>
            </P>
          </Grid>
        </Grid>
      </Container>
    </SectionWrapper>
    </Div>
  )
}

export default Footer